"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const Schedule = _ref => {
  let {
    title = 'Schedule',
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.688 9.969v7l6 3.563-1 1.688-7-4.25v-8h2zM16 27.344q2.188 0 4.141-0.844t3.406-2.297 2.297-3.391 0.844-4.156q0-2.188-0.844-4.141t-2.297-3.406-3.391-2.297-4.156-0.844q-2.188 0-4.141 0.844t-3.406 2.297-2.297 3.406-0.844 4.141q0 2.219 0.844 4.156t2.297 3.391 3.391 2.297 4.156 0.844zM16 3.344q2.75 0 5.188 1.047t4.234 2.859 2.844 4.234 1.047 5.172q0 2.781-1.047 5.203t-2.844 4.234-4.219 2.844-5.203 1.031q-2.75 0-5.188-1.031t-4.234-2.844-2.844-4.234-1.047-5.203q0-2.75 1.047-5.172t2.844-4.234 4.219-2.859 5.203-1.047z"
  }));
};
var _default = exports.default = (0, _ikon.default)(Schedule);
Schedule.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Schedule",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Schedule'",
        "computed": false
      },
      "required": false
    }
  }
};